import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';

// DV-01 → HS-1149: TanStack's flat file convention makes `certifications.$id.tsx` the PARENT of
// the already-shipped `certifications.$id.edit.tsx`. Rendering the detail component here directly
// would leave the matched edit child nowhere to mount, and the editor would become unreachable —
// the exact defect HS-1149 fixed on four other entities. A layout that renders an `<Outlet />` is
// what `groups.$id.tsx` has done since.
export const Route = createFileRoute('/_dashboard/certifications/$id')({
  beforeLoad: requireRoute('/certifications/$id'),
  component: Outlet,
});
